import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { catchError, map, of, switchMap } from 'rxjs';

import { loadSessionSuccess } from 'src/app/features/session/store/actions/session.actions';
import { FeatureManagementService } from '../../services/feature-management.service';
import {
    loadFeatureFlags, loadFeatureFlagsFailed, loadFeatureFlagsSuccess,
} from '../actions/feature-flags.actions';

@Injectable()
export class FeatureFlagsEffects {
    private readonly actions$ = inject(Actions);
    private readonly featureManagementService = inject(FeatureManagementService);

    loadFeatureFlags$ = createEffect(() =>
        this.actions$.pipe(
            ofType(loadFeatureFlags),
            switchMap(() =>
                this.featureManagementService.getFeatureFlags().pipe(
                    map((featureFlags) => {
                      return loadFeatureFlagsSuccess({ featureFlags })
                    }),
                    catchError((error) => {
                        return of(loadFeatureFlagsFailed({ error }));
                    }),
                ),
            ),
        ),
    );

    loadFeatureFlagsPostAuthentication$ = createEffect(() =>
        this.actions$.pipe(
            ofType(loadSessionSuccess),
            switchMap(() =>
                this.featureManagementService.getPostAuthenticationFeatureFlags().pipe(
                    map((featureFlags) => loadFeatureFlagsSuccess({ featureFlags })),
                    catchError((error) => of(loadFeatureFlagsFailed({ error }))),
                ),
            ),
        ),
    );
}
